import React, { useEffect, useState } from "react";
import {
  Grid,
  List,
  ListItem,
  Collapse,
  Typography,
  Container,
  TextField,
  Button,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { Link } from "gatsby";

const useStyles = makeStyles((theme) => ({
  footerSectionTitle: {
    textTransform: "uppercase",
    fontSize: "14px",
    fontWeight: 700,
    marginBottom: 10,
  },
  footerHeader: {
    borderBottom: "1px solid rgb(230,230,230)",
  },

  footerItem: {
    fontSize: "14px",
    marginBottom: 5,
    fontWeight: 400,
    color: "black",
  },
  textField: {
    width: "100%",
    paddingRight: 25,
    marginBottom: 30,
  },
  inputFont: {
    fontSize: "14px",
    color: "rgb(160,160,160)",
    letterSpacing: 1.2,
  },
  subscribeBtn: {
    padding: "15px 30px",
    width: "200px",
    fontWeight: 600,
    fontSize: "14px",
    borderRadius: 60,
    marginTop: 15,
  },
}));

const DesktopFooter = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState({
    1: false,
  });

  const handleClick = (index) => {
    setOpen({ [index]: !open[index] });
  };

  const data = useStaticQuery(graphql`
    query {
      logoBlack: file(relativePath: { eq: "logo/take-shape-header-logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);

  return (
    <Grid container>
      <Container>
        <Grid item container xs={12}>
          <Grid item container xs={12} className={classes.footerBody}>
            {/* Links */}
            <Grid container item xs={6}>
              {/* About */}
              <Grid item container xs={3} align="left">
                <Grid item xs={12}>
                  <Link color="inherit" to="/about-us">
                    <Typography className={classes.footerSectionTitle}>
                      About Us
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/contact-us">
                    <Typography className={classes.footerItem}>
                      Contact Us
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/our-story">
                    <Typography className={classes.footerItem}>
                      Who are we?
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/why-choose-tsa">
                    <Typography className={classes.footerItem}>
                      Why travel with us?
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/our-team">
                    <Typography className={classes.footerItem}>
                      Our Team
                    </Typography>
                  </Link>
                </Grid>
              </Grid>
              {/* Countries 1 */}
              <Grid item container xs={3} align="left">
                <Grid item xs={12}>
                  <Link color="inherit" to="/about-us">
                    <Typography className={classes.footerSectionTitle}>
                      Where we go
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/australia">
                    <Typography className={classes.footerItem}>
                      Australia
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/new-zealand">
                    <Typography className={classes.footerItem}>
                      New Zealand
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/japan">
                    <Typography className={classes.footerItem}>
                      Japan
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/cambodia">
                    <Typography className={classes.footerItem}>
                      Cambodia
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/morocco">
                    <Typography className={classes.footerItem}>
                      Morocco
                    </Typography>
                  </Link>
                </Grid>
              </Grid>
              {/* Countries 1 */}
              <Grid item container xs={3} align="left">
                <Grid item xs={12}>
                  <Link color="inherit" to="/about-us">
                    <Typography className={classes.footerSectionTitle}>
                      Resources
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/australia">
                    <Typography className={classes.footerItem}>
                      Australia
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/new-zealand">
                    <Typography className={classes.footerItem}>
                      New Zealand
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/japan">
                    <Typography className={classes.footerItem}>
                      Japan
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/cambodia">
                    <Typography className={classes.footerItem}>
                      Cambodia
                    </Typography>
                  </Link>
                  <Link color="inherit" to="/morocco">
                    <Typography className={classes.footerItem}>
                      Morocco
                    </Typography>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            {/* Subscribe */}
            <Grid
              item
              container
              xs={6}
              justify="flex-end"
              alignItems="baseline"
            >
              <Grid item container xs={9}>
                <Typography
                  className={classes.footerSectionTitle}
                  inputprops={{
                    classes: {
                      input: classes.inputFont,
                    },
                  }}
                  style={{ marginBottom: 20 }}
                >
                  Subscribe to newsletter
                </Typography>
                <Grid item xs={12}>
                  <TextField
                    className={classes.textField}
                    placeholder="Email"
                    InputProps={{
                      classes: {
                        input: classes.inputFont,
                      },
                    }}
                  ></TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    className={classes.textField}
                    placeholder="First Name"
                    InputProps={{
                      classes: {
                        input: classes.inputFont,
                      },
                    }}
                  ></TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    className={classes.textField}
                    placeholder="Last Name"
                    InputProps={{
                      classes: {
                        input: classes.inputFont,
                      },
                    }}
                  ></TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    className={classes.subscribeBtn}
                  >
                    Subscribe
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={6}
              style={{ marginTop: -35, color: "white" }}
            >
              {/* icons */}
              <a href="https://www.instagram.com/takeshapeadventures/?hl=en">
                <div
                  style={{
                    width: 34,
                    height: 34,
                    marginRight: 10,
                    background: "#302A3D",
                    borderRadius: 160,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  >
                    <svg
                      role="img"
                      viewBox="0 0 24 24"
                      style={{ fill: "white" }}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
                    </svg>
                  </div>
                </div>
              </a>
              <a href="https://www.facebook.com/TakeShapeAdventures/">
                <div
                  style={{
                    width: 34,
                    height: 34,
                    background: "#302A3D",
                    borderRadius: 160,
                    marginRight: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  >
                    <svg
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      style={{ fill: "white" }}
                    >
                      <title>Facebook icon</title>
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </div>
                </div>
              </a>
              <a href="https://au.linkedin.com/company/take-shape-adventures">
                <div
                  style={{
                    width: 34,
                    height: 34,
                    background: "#302A3D",
                    borderRadius: 160,
                    marginRight: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  >
                    <svg
                      role="img"
                      viewBox="0 0 24 24"
                      style={{ fill: "white" }}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>LinkedIn icon</title>
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </div>
                </div>
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Grid
        xs={12}
        container
        item
        style={{
          background: "#302A3D",
          marginTop: 45,
          padding: "20px 0px",
          color: "white",
        }}
      >
        <Container>
          <Grid container justify="space-between">
            <Grid item xs={6}>
              <Typography variant={"h6"} style={{ fontSize: 14 }} align="left">
                © Copyright 2020 Take Shape Adventures. All Rights Reserved.
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant={"h6"} style={{ fontSize: 14 }} align="right">
                Privacy & Cookies | Booking Terms & Conditions | Site Map
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </Grid>
  );
};
export default DesktopFooter;
